module.exports = __webpack_public_path__ + "img/wealth_activation.2bd588d6.svg";